export type NavItem = { label: string; href: string }

export const NAV_ITEMS: NavItem[] = [
  { label: 'Forms', href: '/dashboard' },
  { label: 'Billing', href: '/dashboard/billing' },
  { label: 'Account', href: '/dashboard/account' },
]

// The item whose href is the longest prefix of the current URL, so that
// `/dashboard/billing` selects Billing and not Forms.
export function currentNavItem(url: string, items: NavItem[] = NAV_ITEMS): NavItem | undefined {
  const path = url.split(/[?#]/)[0].replace(/\/+$/, '') || '/'

  return items
    .filter((item) => path === item.href || path.startsWith(`${item.href}/`))
    .sort((a, b) => b.href.length - a.href.length)[0]
}
